// extracted by mini-css-extract-plugin
export var icon = "_bc-3";
export var subtitle = "_bc-2";
export var title = "_bc-1";
export var value = "_bc-0";